<template>
  <div class="main-content">
    <!-- 页面标题 -->
    <div class="title">{{ $t('giftCardOrder.title') }}</div>

    <!-- 搜索栏 -->
    <div class="search-box">
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('giftCardOrder.orderNo')">
          <el-input v-model="searchForm.orderNo" :placeholder="$t('giftCardOrder.inputOrderNo')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.status')">
          <el-select v-model="searchForm.status" :placeholder="$t('giftCardOrder.selectStatus')" clearable>
            <el-option :label="$t('giftCardOrder.pending')" :value="0"></el-option>
            <el-option :label="$t('giftCardOrder.paid')" :value="1"></el-option>
            <el-option :label="$t('giftCardOrder.cancelled')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('common.search') }}</el-button>
          <el-button @click="resetSearch()">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据列表 -->
    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%">
      <el-table-column prop="orderNo" :label="$t('giftCardOrder.orderNo')" align="center"></el-table-column>
      <el-table-column prop="amount" :label="$t('giftCardOrder.amount')" align="center">
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="paymentMethod" :label="$t('giftCardOrder.paymentMethod')" align="center">
        <template slot-scope="scope">
          {{ scope.row.paymentMethod === 'wechat' ? $t('giftCardPurchase.wechatPay') : scope.row.paymentMethod === 'alipay' ? $t('giftCardPurchase.alipay') : scope.row.paymentMethod }}
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('common.status')" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'warning' : scope.row.status === 1 ? 'success' : 'info'">
            {{ scope.row.status === 0 ? $t('giftCardOrder.pending') : scope.row.status === 1 ? $t('giftCardOrder.paid') : $t('giftCardOrder.cancelled') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('common.createTime')" align="center"></el-table-column>
      <el-table-column prop="payTime" :label="$t('giftCardOrder.payTime')" align="center"></el-table-column>
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 0" type="text" @click="handlePay(scope.row.orderNo)">{{ $t('giftCardOrder.pay') }}</el-button>
          <el-button v-if="scope.row.status === 0" type="text" @click="handleCancel(scope.row.orderNo)">{{ $t('giftCardOrder.cancel') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        orderNo: '',
        status: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http({
        url: '/giftcardorder/page',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'orderNo': this.searchForm.orderNo,
          'status': this.searchForm.status
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        orderNo: '',
        status: ''
      }
      this.getDataList()
    },
    // 支付订单
    handlePay(orderNo) {
      this.$confirm(this.$t('giftCardOrder.confirmPay'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/giftcardorder/pay',
          method: 'post',
          data: {
            'orderNo': orderNo
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('giftCardOrder.paySuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 取消订单
    handleCancel(orderNo) {
      this.$confirm(this.$t('giftCardOrder.confirmCancel'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/giftcardorder/cancel',
          method: 'post',
          data: {
            'orderNo': orderNo
          }
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('giftCardOrder.cancelSuccess'),
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.title {
  font-size: 22px;
  margin-bottom: 20px;
}
.search-box {
  margin-bottom: 20px;
}
</style> 
 